import { Controller } from 'stimulus'

export default class extends Controller {
  initialize() {
    this.handleClick = this.handleClick.bind(this)
  }

  connect() {
    // Find the <strong> element inside this controller's element
    // Based on Prismic content
    this.scrollTrigger = this.element.querySelector('strong')

    // If the element exists and contains the words "Scroll down"
    if (this.scrollTrigger && this.scrollTrigger.textContent.includes("Scroll down")) {
      this.scrollTrigger.addEventListener('click', this.handleClick)
      // Add a CSS class to indicate it's clickable
      this.scrollTrigger.classList.add('cursor-pointer')
    }
  }

  disconnect() {
    // Prevent memory leaks or duplicate handlers
    if (this.scrollTrigger) {
      this.scrollTrigger.removeEventListener('click', this.handleClick)
    }
  }

  themesContent() {
    return document.getElementById('theme_grid-6') || document.getElementById('theme_browser_lite-6') 
  }

  // Event handler for click events on the scrollTrigger element
  handleClick(event) {
    event.preventDefault()

    // Find the theme_filter target element 
    const target = this.themesContent()

    if (!target) return // If target not found, exit early

    const offset = 100
    const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    })
  }
}
